/** Mask secret string values for display (keys stay visible). */
export function maskCredentialValue(value: unknown): unknown {
  if (value === null || value === undefined) return value;
  if (typeof value === 'boolean' || typeof value === 'number') return value;
  if (typeof value === 'string') {
    if (value.length <= 4) return '••••';
    const tail = value.slice(-4);
    const head = value.length > 8 ? value.slice(0, 2) : '';
    const middleLen = Math.min(8, Math.max(2, value.length - head.length - tail.length));
    return `${head}${'•'.repeat(middleLen)}${tail}`;
  }
  if (Array.isArray(value)) return value.map((item) => maskCredentialValue(item));
  if (typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [key, nested] of Object.entries(value as Record<string, unknown>)) {
      out[key] = maskCredentialValue(nested);
    }
    return out;
  }
  return '••••';
}

export function maskCredentials(payload: Record<string, unknown>): Record<string, unknown> {
  return maskCredentialValue(payload) as Record<string, unknown>;
}
